import { useEffect } from 'react';
import { mediaQueryAction } from '../../store/slices/media-query.slice';
import { dispatch } from '../../store';
import { useContainer } from '../useContainer';
import { GlobalApi } from '../../util/Global';

export const useSetResizeListener = () => {
    const globalApi = useContainer(GlobalApi);

    useEffect(() => {
        const updateMedia = () => {
            dispatch(mediaQueryAction.updateWidth({ width: globalApi.innerWidth() }));
        };
        updateMedia();
        globalApi.addEventListener('resize', updateMedia);

        return () => globalApi.removeEventListener('resize', updateMedia);
    }, []);
};
